import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { Lesson, TestItem } from '../../interfaces';
import { NavController } from '@ionic/angular';
import { UiServices } from 'src/app/services/ui-services';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { ModuleTestService } from '../services/module-test.service';

@Component({
  selector: 'app-class-show',
  templateUrl: './class-show.page.html',
  styleUrls: ['./class-show.page.scss'],
})
export class ClassShowPage implements OnInit {
  public class: Lesson;
  public inscriptionId = '';

  constructor(
    private httpSv: HttpService,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private uiSv: UiServices,
    private paramSv: ParamServicesService,
    private moduleTestSv: ModuleTestService
  ) {}

  async ngOnInit() {
    this.inscriptionId = this.route.snapshot.paramMap.get('incription_id');
    const id = this.route.snapshot.paramMap.get('class_id');
    const res = await this.httpSv.itemIndex(
      'learningLessons',
      '',
      { id, inscriptionId: this.inscriptionId },
      'show'
    );
    if (!res.status) {
      if (res?.data?.reazon) {
        if (!this.paramSv.testImages.length) {
          this.paramSv.emitTestImg$.subscribe(() =>
            this.showSuspension(res.data, this.inscriptionId)
          );
        } else {
          this.showSuspension(res.data, this.inscriptionId);
        }
      } else {
        await this.uiSv.presentAlert(
          'Debes ver la clase anterior para poder acceder.',
          false
        );
        this.navCtrl.navigateRoot(
          `virtual-class/module/${this.inscriptionId}/${res.data.learningModuleId}`
        );
      }
    } else {
      this.class = res.data;
    }
  }

  showSuspension(data, inscriptionId: string) {
    this.moduleTestSv.showReasonModal(data as TestItem, inscriptionId);
  }

  async markAsView() {
    const res = await this.httpSv.itemAction(
      {
        learningLessonId: this.class.id,
      },
      'learning',
      'progress'
    );

    if (res.status) {
      await this.navCtrl.navigateBack(
        `/virtual-class/module/${this.inscriptionId}/${this.class.module.id}`
      );
    }
  }
}
